<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Outbound Bulk Upload
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Upload Bulk Order

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <ul class="text-left mb-2">
            <li>Order Reference Number has to be unique.</li>
            <li>Address Line1, Address Line2 should be below 90 characters.</li>
            <li>Order Quantity should be full integer number.</li>
          </ul>
        </v-form>
      </v-card-text>
      <v-divider class="mb-3"></v-divider>
      <v-card-text class="pb-0 pl-1">
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col md="6" class="pl-3 pb-0">
                <v-autocomplete
                  v-model="warehouse"
                  :items="warehouses"
                  item-text="name"
                  item-value="id"
                  label="Select Warehouse"
                  placeholder="Start typing to Search"
                  class="pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Warehouse']"
                  outlined
                  @change="
                    getStores(selectedClient, warehouse), fetchClientList()
                  "
                ></v-autocomplete>
              </v-col>
              <v-col
                md="6"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pl-3 pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Client']"
                  outlined
                  @change="getStores(selectedClient, warehouse)"
                ></v-autocomplete>
              </v-col>

              <v-col md="6" class="pb-0 pl-3">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="pb-0 pl-3">
                <v-autocomplete
                  v-model="allocation_filter"
                  label="Allocation FIlter"
                  :rules="[(v) => !!v || 'Allocation Filter required.']"
                  item-text="text"
                  item-value="value"
                  class="required"
                  :items="allocationfilters"
                  outlined
                  @change="getTemplate(allocation_filter)"
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="custom">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  class="required pl-3"
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  label="Select your Order File"
                  outlined
                  :rules="[(v) => !!v || 'Please Select Order File']"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left mt-0">
              <v-col class="pl-6">
                <v-btn
                  color="green"
                  dark
                  class="mr-3"
                  @click="listPage"
                  v-if="checkPermission('app_ecom_vendors:excel_details')"
                >
                  Uploaded List
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-3"
                  :loading="downloader"
                  v-if="newTemplate"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchClientList();
    });
    if (this.value == "") {
      this.value = this.userCategory.user_category;
    }
  },
  data() {
    return {
      infor_storer_id: null,
      stores: [],
      date: null,
      dateMenu: false,
      page: "listPage",
      clients: [],
      selectedClient: null,
      total: 0,
      productsLoader: false,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      clientLoader: false,
      isFlag: false,
      value: "",
      warehouses: [],
      order_no: "",
      name: null,
      phone: "",
      email: "",
      address1: "",
      address2: "",
      ErrorMessage: [],
      newTemplate: null,

      allocationfilters: [
        {
          text: "NORMAL",
          value: "NORMAL",
        },
        {
          text: "LPN/Pallet ID",
          value: "IDREQUIRED",
        },
        {
          text: "ASN (Lottable02)",
          value: "LOTTABLE02",
        },
        {
          text: "BOE (Lottable03)",
          value: "LOTTABLE03",
        },
        {
          text: "Mfg Date (Lottable04)",
          value: "LOTTABLE04",
        },

        {
          text: "Expiry Date (Lottable05)",
          value: "LOTTABLE05",
        },
        {
          text: "Batch (Lottable06)",
          value: "LOTTABLE06",
        },
        {
          text: "Lottable07",
          value: "LOTTABLE07",
        },
        {
          text: "Lottable08",
          value: "LOTTABLE08",
        },
        {
          text: "Lottable09",
          value: "LOTTABLE09",
        },
        {
          text: "Lottable10",
          value: "LOTTABLE10",
        },
      ],
    };
  },
  created() {
    this.getwarehouse();
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
    // this.getInforWarehouseList().then((response) => {
    //   this.warehouses = response.data.result;
    // });
  },
  methods: {
    ...mapActions([
      "downloadOutoundOrderTemplate",
      "uploadoutboundBulkList",
      "fetchClient",
      "snackBar",
      "getInforWarehouseList",
      "downloadFlagFalse",
      "getWarehouseStores",

      "getOutboundBulkSettings",
    ]),

    downloadTemplate() {
      this.downloader = true;
      let url = `/api/file_download?file_path=fulfillmentb2b/${this.newTemplate}`;
      this.downloadOutoundOrderTemplate(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    getTemplate(filter) {
      if (this.allocation_filter && this.selectedClient) {
        let payload = {
          allocation_filter: filter,
          client_id: this.selectedClient,
        };
        this.getOutboundBulkSettings(payload).then((response) => {
          this.newTemplate = response.data.excel_name;
        });
      }
    },
    getwarehouse() {
      this.warehouse = "";
      this.infor_storer_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },
    getStores(client, id) {
      let payload = {
        client_id: client,
        warehouse_id: id,
      };
      if (client)
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      if (this.warehouse) payload.append("warehouse", this.warehouse);
      if (this.infor_storer_id)
        payload.append("storer_id", this.infor_storer_id);
      if (this.allocation_filter)
        payload.append("allocation_filter", this.allocation_filter);

      if (this.file) payload.append("data_file", this.file, this.file.name);
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        payload.append("client_id", this.selectedClient);
      }
      this.uploadoutboundBulkList(payload)
        .then((res) => {
          this.fileLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$refs.form.reset();
          this.date = null;
          this.$router.push("/outbound-list");
        })
        .catch(() => {
          this.fileLoader = false;
        });
    },
    close() {
      this.selectedClient = null;
      this.file = null;
      this.fileLoader = false;
      this.$refs.form?.reset();
      this.date = null;
      this.$router.push("/outbound-list");
    },
    fetchClientList() {
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          warehouse_id: this.warehouse,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    listPage() {
      this.$router.push({
        name: "outboundBulkordersStatusList",
        params: {
          type: "outbound_upload,outbound_bulk_upload",
        },
      });
    },
  },
};
</script>
<style>
.custom .v-text-field {
  padding-top: 0;
}
</style>
